import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslocoService} from "@ngneat/transloco";
import { HttpClient } from "@angular/common/http";
import {MatDialog} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {SpecialCompbaser} from "../../compbaser";
import {LocalStoreService, StoreSelectorsService, UserService} from "../../../services";
import {compareIds, DEFAULT_RESELLER_ID, doNothing, isHostDev, isHostDevOrLocal, isNullOrUndefOrEmpty, playSound, popupWindow, saveDownloadedData} from "../../../common";
import {IAppStatic, IOS, IUser} from "../../../interfaces";
import {IChatEnvelope, IChatGlobal, IChatStats} from "../../../interfaces/chat-interface";
import {Lib} from "../../../../libs/Lib";
import {fromEvent, mergeWith, Subject, switchMap, throttleTime, timer} from "rxjs";
import {faFolder, faFolderOpen} from "@fortawesome/free-solid-svg-icons";
import {ChatHelper} from "../chat-helper";
import {map, startWith} from "rxjs/operators";
import {once} from "../../../decorators/once-decorator";
import {actionPostChatSessionId, actionPostChatStats} from "../../../store/actions/user.actions";
import {DialogPopComponent} from "../../dialog-pop/dialog-pop.component";

enum ChatModeEnum {
    WAITING,
    UNAVAILABLE,
    AVAILABLE,
    CHATTING,
    DISCONNECTED
}

type UserType = 'GUEST' | 'USER' | 'EMAIL';


@Component({
    selector: 'app-chat-customer',
    templateUrl: './chat-customer.component.html',
    styleUrls: ['../chat.component.scss']
})
export class ChatCustomerComponent extends SpecialCompbaser implements OnInit {

    readonly faFolder = faFolder;
    readonly faFolderOpen = faFolderOpen;
    readonly studioId: string;

    devMode;
    videoUrl;
    filter = "";
    allowAccess = null;
    server;
    port;
    userName;
    timerReset$;
    timerSub;
    payload: IChatEnvelope;
    m_popupMode = false;
    m_modeEnum = ChatModeEnum;
    m_modeState: ChatModeEnum = ChatModeEnum.WAITING;
    m_isSupportOn = false;
    m_totalSupport = 0;
    m_supportIds = [];
    m_supportNames = [];
    m_chatGlobal: IChatGlobal;
    m_totalCustomers = 0;
    m_conversations: IChatEnvelope[] = [];
    m_newUserName = '';
    m_userType: 'USER' | 'GUEST' | 'EMAIL';
    m_welcomePending = null;
    m_messageModel = '';
    m_currentSession: IChatEnvelope;
    m_ipAddress = null;
    m_OS: IOS = null;
    m_socketRef;
    m_ringOn;
    m_user: IUser;
    isEmojiPickerVisible = false;
    chatHelp: ChatHelper = new ChatHelper();
    mouseClick$ = new Subject();
    typingTimeout;
    m_userTyping = false;
    m_userTypingSound;
    resellerId;
    val: number;
    idleSecondsReminder = 60;
    appStatic: IAppStatic;
    socket;
    stringJSPipeArgs = {toDateFromTimestamp: ['MM-DD-YY hh:mm:ss a', 0]};
    stringJSPipeClean = {split: ['@', 0]};

    constructor(
        private route: ActivatedRoute,
        private localStoreService: LocalStoreService,
        private translocoService: TranslocoService,
        private _http: HttpClient,
        private router: Router,
        private userService: UserService,
        private storeSelector: StoreSelectorsService,
        dialog: MatDialog, private toastr: ToastrService) {
        super(dialog);
        this.devMode = Lib.DevMode();
        this.switchMode(ChatModeEnum.WAITING);
        this.initTimer();
        this.studioId = this.localStoreService.getStorageConfig().studioId;
        this.resellerId = 1;
        this.cod(
            this.storeSelector.getOS().subscribe((i_OS) => {
                this.m_OS = i_OS;
            })
        );
        this.cod(
            this.route.queryParams.subscribe((routeParams) => {
                const chatReseller = routeParams?.chatreseller;
                if (!isNullOrUndefOrEmpty(chatReseller) && !compareIds(chatReseller, '1')) {
                    try {
                        return this.resellerId = Lib.RC4Decrypt(chatReseller);
                    } catch (e) {
                        return this.resellerId = DEFAULT_RESELLER_ID;
                    }
                }
            })
        );
        this.cod(
            this.storeSelector.getLiveChatStatusV2()
                .subscribe((i_chatGlobal) => {
                    /* if chat is under an enterprise admin (reseller !== 1) we force live status to always be available (we do not use monday - friday sched) */
                    if (!compareIds(this.resellerId, '1')) {
                        i_chatGlobal = {
                            sessionId: i_chatGlobal.sessionId,
                            liveStatusV2: 9999,
                            liveStatus: 9999
                        };
                    }
                    this.m_chatGlobal = i_chatGlobal;
                    /* if did not get a reply yet (null) or previously chat session, no need to change states  */
                    if (isNullOrUndefOrEmpty(i_chatGlobal.liveStatusV2) || this.m_chatGlobal.sessionId) return;

                    this.m_isSupportOn = i_chatGlobal.liveStatusV2 > 0;
                    if (this.m_isSupportOn) {
                        this.switchMode(ChatModeEnum.AVAILABLE);
                    } else {
                        this.switchMode(ChatModeEnum.UNAVAILABLE);
                    }
                })
        );
        this.cod(
            this.storeSelector.getAppSettings()
                .subscribe((i_appSettings: IAppStatic) => {
                    this.appStatic = i_appSettings;
                    this.server = this.appStatic.chatService;
                })
        );
    }

    @Input()
    set setResellerId(i_reseller) {
        this.resellerId = i_reseller;
    }

    @ViewChild('txtMain', {static: false}) set txtMain(element) {
        if (!element) return;
        this.initTyping(element);
    }

    ngOnInit() {
        if (this.route?.snapshot?.data?.popup) {
            this.m_popupMode = true;
        }
        this.cod(
            this.storeSelector.getUser(true)
                .subscribe((i_user: IUser) => {
                    if (i_user) {
                        this.m_user = i_user;
                        this.userName = this.m_newUserName = this.m_user.username;
                        this.m_userType = "USER";
                    } else {
                        this.m_userType = "GUEST";
                        const guest = this.localStoreService.getStorageValConfig('noLoginUserName');
                        if (!isNullOrUndefOrEmpty(guest)) {
                            this.userName = guest;
                        } else {
                            this.userName = 'Guest';
                        }
                    }
                    Lib.DevShow(`init chat >> user:${this.userName} reseller:${this.resellerId} polling:${this.m_isSupportOn}`);
                    /* continuation of a chat session */
                    if (this.m_chatGlobal.sessionId) {
                        this.initSocket();
                    }
                })
        );
    }

    @once
    initTyping(element) {
        this.cod(
            fromEvent(element.nativeElement, 'keyup')
                .pipe(
                    throttleTime(500),
                    map((e: any) => e.target.value),
                    mergeWith(this.mouseClick$)
                ).subscribe((v) => {
                if (v === '') return;
                this.onSendTyping();
            })
        );
    }

    initSocket() {
        this.storeSelector.dispatch(actionPostChatSessionId({sessionId: Lib.RandomString()}));
        this.payload = {id: this.studioId, resellerId: this.resellerId, user: this.userName, role: 'customer'};
        this.socket = this.userService.initSocketChatService(this.server);
        this.socket.on('connect', async () => {
            Lib.DevShow(`connected on socket:${this.socket.id} id:id`);
            this.send('', 'joinRoom');
        });

        this.socket.on('joinedRoom', async (ipAddress) => {
            this.m_ipAddress = ipAddress;
            this.send(this.studioId, 'getConversation');
            this.onRing();
            this.sendStats('start');
        });

        this.socket.on('accept', (msg) => {
            // alert('accept');
            Lib.DevShow('accept ' + msg);
        });

        this.socket.on('leftBuilding', (msg) => {
            this.toastr.info(this.translocoService.translate('toast.supportBeRightBack2', {}, this.translocoService.getActiveLang()));
        });

        this.socket.on('getConversation', (replayData) => {
            if (this.m_supportIds.indexOf(replayData.to) === -1) {
                this.m_supportNames.push(replayData.user);
                this.m_supportIds.push(replayData.to);
            }
            this.m_conversations = [];
            if (replayData && replayData.talk) {
                this.m_conversations = replayData.talk;
                this.chatHelp.scrollToBottom(this.m_conversations);
            }
            this.onSendWelcome();
            this.switchMode(ChatModeEnum.CHATTING);
        });

        // this.socket.on('ringing', (msg) => {
        //     this.newUserAlert(msg);
        // });

        this.socket.on('private', (envelope: IChatEnvelope) => {
            /* retrieve all messages, Support mode only retrieve messages of active / selected customer  */
            if (this.isUserTyping(envelope)) return;
            this.clearIsTyping();
            this.m_currentSession = envelope;
            this.m_conversations.push(envelope);
            this.chatHelp.scrollToBottom(this.m_conversations);
            this.timerReset();
            playSound(4);
        });

        this.socket.on('stats', (payload) => {
            this.m_totalSupport = payload.support;
            this.m_totalCustomers = payload.customer;
        });

        this.socket.on('talking', (payload: IChatEnvelope) => {
            this.switchMode(ChatModeEnum.CHATTING);
            playSound(5);
            clearInterval(this.m_ringOn);
            this.sendStats('talking', payload.user);
            if (this.m_supportIds.indexOf(payload.id) > -1) return;
            this.m_supportIds.push(payload.id);
            this.m_supportNames.push(payload.user);
            this.onSendWelcome();
        });

        this.socket.on('remove', (payload: IChatEnvelope) => {
            this.sendStats('end');
            Lib.DevShow('remove ' + payload.user);
            this.m_supportIds.indexOf(payload.id) > -1 ? this.m_supportIds.splice(this.m_supportIds.indexOf(payload.id), 1) : doNothing();
            this.m_supportNames.indexOf(payload.user) > -1 ? this.m_supportNames.splice(this.m_supportNames.indexOf(payload.id), 1) : doNothing();
            if (this.m_supportIds.length === 0) {
                this.m_supportIds = [];
                this.m_supportNames = [];
                this.disconnected();
            }
        });

        this.socket.on('disconnect', () => {
            Lib.DevShow('disconnected...');
        });

        this.m_socketRef = this.socket.on("connect_error", (err) => {
            Lib.DevShow('chat err ' + err);
            this.toastr.error(this.translocoService.translate('toast.firewallChatError2', {}, this.translocoService.getActiveLang()) + ' ' + this.port);

        });

        this.socket.on('error', (err) => {
            alert('chat error ' + err);
        });

        this.socket.onAny((a, b) => {
            Lib.DevShow('any ' + a + ' ' + b);
        });
    }

    send(to, cmd, body = '') {
        const payload = this.chatHelp.getPayload(this.payload);
        if (!payload) return;
        payload.to = to;
        payload.body = body;
        this.socket.emit(cmd, payload);
    }

    isUserTyping(envelope): boolean {
        if (envelope.body !== '::typing::') return false;
        this.m_userTyping = true;
        if (this.m_userTypingSound) this.m_userTypingSound.pause();
        this.m_userTypingSound = playSound(7);
        if (this.typingTimeout) clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
            this.m_userTyping = false;
            this.m_userTypingSound.pause();
        }, 2000);
        return true;
    }

    switchMode(i_mode: ChatModeEnum) {
        console.log(`### changing state from ${this.m_modeState} to ${i_mode}`);
        this.m_modeState = i_mode;
    }

    clearIsTyping() {
        if (this.typingTimeout) clearTimeout(this.typingTimeout);
        this.m_userTyping = false;
        this.m_userTypingSound.pause();
    }

    downloadChat() {
        let data = '';
        this.m_conversations.forEach((v: IChatEnvelope) => {
            data = `${data}<br/> [${v.role}] ${v.body}`;
        });
        saveDownloadedData('transcription.html', data);
    }

    onPopupChat() {
        const msg = this.translocoService.translate('message.continueSession', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {name: msg, showCancel: true}
        });
        dialogRef.afterClosed().subscribe((r) => {
            if (r) {
                Lib.openLiveChat(true, this.m_user, this.appStatic);
                this.killSocket();
                this.switchMode(ChatModeEnum.DISCONNECTED);
            }
        });
    }

    onSendPrivate(i_userInputModel) {
        this.mouseClick$.next(Math.random());
        if (isNullOrUndefOrEmpty(i_userInputModel)) return;
        i_userInputModel = this.chatHelp.fixLinks(i_userInputModel);
        this.m_supportIds.forEach((id) => {
            this.send(id, 'private', i_userInputModel);
        });
        this.send(this.studioId, 'getConversation');
        /* space out ongoing so does not switchMap cancel switchMap of 'talking'; */
        setTimeout(() => this.sendStats('ongoing'), 333);
        this.m_messageModel = '';
        this.timerReset();
    }

    onSendWelcome() {
        if (!this.m_welcomePending) return;
        this.m_welcomePending = `${this.m_welcomePending} | ip:${this.m_ipAddress} | os:${this.m_OS?.family}`;
        this.onSendPrivate(this.m_welcomePending);
        this.m_welcomePending = null;
    }

    addWelcomeMessage(i_firstMessage) {
        if (this.m_user) {
            this.m_welcomePending = `Welcome ${this.m_user.username} from business ${this.m_user.businessId} / ${this.m_user.resellerId} <br/><hr/> ${i_firstMessage}`;
        } else if (this.userName) {
            const name = this.userName;
            this.m_welcomePending = `Welcome ${name}, <br/><hr/> ${i_firstMessage}`;
        }
    }

    onSendTyping() {
        this.m_supportIds.forEach((id) => {
            this.send(id, 'private', '::typing::');
        });
    }

    disconnected() {
        this.toastr.info(this.translocoService.translate('toast.chatEnded', {}, this.translocoService.getActiveLang()), '', {disableTimeOut: true, positionClass: "toast-top-full-width"});
        setTimeout(() => {
            this.router.navigateByUrl('/');
        }, 5000);
    }

    sendReminder() {
        if (this.m_modeState === ChatModeEnum.CHATTING) return;
        this.onRing();
    }

    onRing() {
        this.send('', 'ring', '');
    }

    async broadcastStats(milliseconds = 0) {
        if (milliseconds === 0) return this.send('', 'broadcastStats', '');
        await Lib.wait(milliseconds);
        this.send('', 'broadcastStats', '');
    }

    async onRemoveCallCustomer() {
        const msg = this.translocoService.translate('message.sureLeave', {}, this.translocoService.getActiveLang());
        const dialogRef = this.dialog.open(DialogPopComponent, {
            height: '200px',
            width: '400px',
            data: {name: msg, showCancel: true}
        });
        dialogRef.afterClosed().subscribe(async (r) => {
            if (r) {
                this.sendStats('end');
                this.m_currentSession = null;
                this.m_conversations = [];
                this.m_supportIds.forEach((id) => {
                    const payload = this.chatHelp.getPayload(this.payload);
                    payload.remove = payload.id;
                    payload.id = id;
                    payload.to = this.userName;
                    this.socket.emit('remove', payload);
                });
                this.m_supportIds = [];
                this.m_supportNames = [];
                await this.broadcastStats(100);
                this.switchMode(ChatModeEnum.DISCONNECTED);
                this.disconnected();
                // this.killSocket();
            }
        });
    }

    sendStats(command, support = '') {
        if (isNullOrUndefOrEmpty(this.m_chatGlobal?.sessionId)) {
            if (Lib.DevMode() || isHostDev()) throw new Error('session id undefined need to check why');
            return;
        }
        const payload: IChatStats = {
            sessionId: this.m_chatGlobal.sessionId,
            studioId: this.studioId,
            businessId: this.m_user?.businessId,
            customer: this.userName,
            support,
            resellerId: String(this.resellerId),
            command
        };
        this.storeSelector.dispatch(actionPostChatStats({payload}));
    }

    initTimer() {
        this.timerReset$ = new Subject();
        this.timerSub = this.timerReset$.pipe(
            startWith(0),
            switchMap(() => timer(1000, 1000))
        ).subscribe(val => {
            this.val = val;
            if (this.val > this.idleSecondsReminder) {
                this.timerReset();
                this.sendReminder();
            }
        });
    }

    timerReset(): void {
        this.timerReset$.next(0);
    }

    public addEmoji(event) {
        this.isEmojiPickerVisible = false;
        const msg = `${this.m_messageModel} <span style="font-size: 2em"> ${event.emoji.native}</span>`;
        this.onSendPrivate(msg);
    }

    public scrollToBottom() {
        this.chatHelp.scrollToBottom();
    }

    onUserSubmitted(userType: UserType, e) {
        this.switchMode(ChatModeEnum.WAITING);
        switch (userType) {
            case 'GUEST': {
                this.userName = e.user; // + '::' + String(Math.random()).replace(/0./, '');
                this.localStoreService.setStorageValConfig('noLoginUserName', this.userName);
                this.allowAccess = true;
                this.initSocket();
                this.addWelcomeMessage(e.firstMessage);
                break;
            }
            case 'USER': {
                this.allowAccess = true;
                this.initSocket();
                this.addWelcomeMessage(e.firstMessage);
                break;
            }
            case 'EMAIL': {
                break;
            }
        }
    }

    killSocket() {
        if (this.socket) this.socket.off();
        if (this.socket) this.socket.offAny();
        if (this.socket) this.socket.off(this.m_socketRef);
        if (this.socket) this.socket.close();
        this.allowAccess = false;
        this.socket = null;
    }

    override destroy() {
        super.destroy();
        this.timerSub.unsubscribe();
        this.killSocket();
    }

    // newUserAlert(envelope: IChatEnvelope) {
    //     this.toastr.success('assistance: ' + envelope.user);
    //     playSound(2);
    // }
}

